import { render, staticRenderFns } from "./DatosCompradoresSgaComponent.vue?vue&type=template&id=87a3848c&scoped=true"
import script from "./DatosCompradoresSgaComponent.vue?vue&type=script&lang=js"
export * from "./DatosCompradoresSgaComponent.vue?vue&type=script&lang=js"
import style0 from "./DatosCompradoresSgaComponent.vue?vue&type=style&index=0&id=87a3848c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a3848c",
  null
  
)

export default component.exports